import { Link } from "react-router-dom";
import { company } from "@/mocks/site";

export default function HomeContactStrip() {
  return (
    <section className="border-y border-foreground-200 bg-background-100 py-8 md:py-10">
      <div className="mx-auto flex w-full max-w-shell flex-col gap-7 px-4 md:px-6 lg:flex-row lg:items-center lg:justify-between lg:gap-10">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 flex-none items-center justify-center border border-foreground-200 bg-background-50 text-primary-600">
            <i className="ri-map-pin-2-line text-[17px]" />
          </span>
          <div>
            <p className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-500">
              Anschrift
            </p>
            <p className="mt-1 text-[13.5px] leading-relaxed text-foreground-900">
              {company.street}, D-{company.zip} {company.city}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 flex-none items-center justify-center border border-foreground-200 bg-background-50 text-primary-600">
            <i className="ri-phone-line text-[17px]" />
          </span>
          <div>
            <p className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-500">
              Telefon
            </p>
            <a
              href={`tel:${company.phoneHref}`}
              className="mt-1 block text-[13.5px] leading-relaxed text-foreground-900 transition-colors hover:text-primary-700"
            >
              {company.phone}
            </a>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 flex-none items-center justify-center border border-foreground-200 bg-background-50 text-primary-600">
            <i className="ri-time-line text-[17px]" />
          </span>
          <div>
            <p className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-500">
              Geschäftszeiten
            </p>
            <p className="mt-1 text-[13px] leading-relaxed text-foreground-800">
              Mo – Do 06:30 – 12:00 / 12:45 – 16:00
              <br />
              Fr 06:30 – 11:30
            </p>
          </div>
        </div>

        <Link
          to="/kontakt"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-foreground-950 bg-foreground-950 px-5 py-3 font-heading text-[11px] font-bold uppercase tracking-[0.14em] text-background-50 transition-colors hover:border-primary-600 hover:bg-primary-600"
        >
          Anfahrt &amp; Kontakt
          <i className="ri-arrow-right-line text-[14px]" />
        </Link>
      </div>
    </section>
  );
}